import type { SxProps, Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

export const F_SIMPLE_DIALOG_PAPER_SX: SystemStyleObject<Theme> = {
  borderRadius: '16px',
  p: 3,
  width: '100%',
  maxWidth: 560,
  minWidth: { xs: 0, sm: 480 },
  minHeight: 240,
};

export const F_SIMPLE_DIALOG_CONTENT_SX: SystemStyleObject<Theme> = {
  px: 0,
  py: 3,
};

export const F_SIMPLE_DIALOG_CONTENT_LOADING_SX: SystemStyleObject<Theme> = {
  display: 'flex',
  flexDirection: 'column',
};

export const F_SIMPLE_DIALOG_ACTION_BUTTON_SX: SxProps<Theme> = {
  minWidth: 130,
  height: 44,
  borderRadius: '10px',
  fontWeight: 600,
};
